const isProd = import.meta.env.MODE === "production";

const VITE_BACKEND_URL = isProd ? import.meta.env.VITE_PROD_BACKEND_URL: import.meta.env.VITE_DEV_BACKEND_URL
export const API_URL = `${VITE_BACKEND_URL}/api`;


